module.exports = __webpack_public_path__ + "img/Toyota-2019-Prius-2.c746bc06.png";